import { render, staticRenderFns } from "./SettingBody.vue?vue&type=template&id=2fa70da5&scoped=true&"
import script from "./SettingBody.vue?vue&type=script&lang=ts&"
export * from "./SettingBody.vue?vue&type=script&lang=ts&"
import style0 from "./SettingBody.vue?vue&type=style&index=0&id=2fa70da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa70da5",
  null
  
)

export default component.exports